export default "__VITE_ASSET__CyvTYLKI__"